export interface Route {
  id: string
  name: string
  url: string
}

export interface RouteWithPreview extends Route {
  previewImageUrl: string
}

export interface StoredDayRoute {
  routeName: string
  routeUrl: string
}

export interface StoredWeek {
  activeDays: string[]
  days: Record<string, StoredDayRoute>
}

export type WeeksFile = Record<string, StoredWeek>

/** @deprecated Used only for one-time migration from events.json */
export interface LegacyEvent {
  id: string
  date: string
  routeName: string
  routeUrl: string
}

export function rwgpsIdFromUrl(url: string): string {
  const match = url.match(/ridewithgps\.com\/routes\/(\d+)/)
  if (!match) throw new Error(`Cannot extract RWGPS route ID from URL: ${url}`)
  return match[1]
}

export function previewImageUrl(routeUrl: string): string {
  const id = rwgpsIdFromUrl(routeUrl)
  return `https://ridewithgps.com/routes/${id}/hover_preview.png`
}
